import React from "react";
import StartConfigButton from "../StartConfigButton/StartConfigButton";
import t from "../../../../utils/common/translation/translator";
import { selectRetrofitSavedConfigurations } from "../../../../store/slices/retrofit";
import { useSelector } from "react-redux";
import { selectCartesianSavedConfigurations } from "../../../../store/slices/cartesian";
import { selectMc12SavedConfigurations } from "../../../../store/slices/mc12";
import { selectLocale } from "../../../../store/slices/common";
import { selectIntegratedDrivesSavedConfigurations } from "../../../../store/slices/integrated_drives";

const StartConfig = ({ availableTechnologies, handleDisplayContinuePopup }) => {
  const locale = useSelector(selectLocale);
  const country = locale.split("-")[1];

  const retrofitSavedConfigurations = useSelector(selectRetrofitSavedConfigurations);
  const cartesianSavedConfigurations = useSelector(selectCartesianSavedConfigurations);
  const mc12SavedConfigurations = useSelector(selectMc12SavedConfigurations);
  const integratedDrivesSavedConfigurations = useSelector(selectIntegratedDrivesSavedConfigurations);

  const latestRetrofitConfigInProgressForCountry = retrofitSavedConfigurations?.filter(
    (config) => config.status === "IN_PROGRESS" && config.country === country
  )?.[0];
  const latestCartesianConfigInProgressForCountry = cartesianSavedConfigurations?.filter(
    (config) => config.status === "IN_PROGRESS" && config.country === country
  )?.[0];
  const latestMc12ConfigInProgressForCountry = mc12SavedConfigurations?.filter(
    (config) => config.status === "IN_PROGRESS" && config.country === country
  )?.[0];
  const lastestIntegratedDrivesConfigInProgressForCountry = integratedDrivesSavedConfigurations?.filter(
    (config) => config.status === "IN_PROGRESS" && config.country === country
  )?.[0];

  return (
    <div className="w-full flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">
      {availableTechnologies.includes("RETROFIT") && (
        <StartConfigButton
          title={t("msizer.ui.start-config-card-title")}
          description={t("msizer.ui.start-config-card-text")}
          type="RETROFIT"
          idLabel="retrofit"
          configurationInProgress={latestRetrofitConfigInProgressForCountry || null}
          handleDisplayContinuePopup={handleDisplayContinuePopup}
        />
      )}
      {availableTechnologies.includes("CARTESIAN") && (
        <StartConfigButton
          title={t("cartesian.ui.start-config-card-title")}
          description={t("cartesian.ui.start-sizing-card-text")}
          type="CARTESIAN"
          idLabel="cartesian"
          configurationInProgress={latestCartesianConfigInProgressForCountry || null}
          handleDisplayContinuePopup={handleDisplayContinuePopup}
        />
      )}
      {availableTechnologies.includes("MC12") && (
        <StartConfigButton
          title={t("mc12.ui.start-config-card-title")}
          description={t("mc12.ui.start-config-card-text")}
          type="MC12"
          idLabel="mc12"
          configurationInProgress={latestMc12ConfigInProgressForCountry || null}
          handleDisplayContinuePopup={handleDisplayContinuePopup}
        />
      )}
      {availableTechnologies.includes("INTEGRATED_DRIVES") && (
        <StartConfigButton
          title={t("integrated_drives.ui.start-config-card-title")}
          description={t("integrated_drives.ui.start-config-card-text")}
          type="INTEGRATED_DRIVES"
          idLabel="integrated-drives"
          configurationInProgress={lastestIntegratedDrivesConfigInProgressForCountry || null}
          handleDisplayContinuePopup={handleDisplayContinuePopup}
        />
      )}
    </div>
  );
};

export default StartConfig;
